"use client";
import Image from "next/image";
import { motion } from "framer-motion";
import { SuitabilityQuestion } from "@/type/commonTypes";

export default function SuitabilityQuestionOptions({
  question,
  onSelect,
}: {
  question: SuitabilityQuestion;
  onSelect: (optionId: number) => void;
}) {
  return (
    <motion.div
      className="flex flex-col items-end"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2, duration: 0.3 }}
    >
      <p className="text-sm font-semibold text-primaryBlack mb-2.5">Select an option</p>
      {question.options.map((opt, j) => (
        <button
          key={j}
          onClick={() => onSelect(opt.id)}
          className={`w-full ${question.isIntro ? "max-w-fit" : "max-w-[85%]"} bg-white text-left border border-primaryBlue px-4 py-2.5 rounded-xl mb-2.5 transition-all duration-300 ease-in-out hover:bg-[#1A51AA26] hover:shadow-md`}
        >
          {question.isIntro ? (
            <p className="text-2xs xs:text-2sm font-semibold text-primaryBlue">{opt.label}</p>
          ) : (
            <div className="flex items-center gap-2.5">
              <Image
                src={`/next_assets/images/suitability-modal/${opt.img}`}
                alt={opt.type}
                width={26}
                height={26}
              />
              <p className="text-2xs xs:text-2sm font-semibold text-black">{opt.label}</p>
            </div>
          )}
        </button>
      ))}
    </motion.div>
  );
}
